import { Component } from '@angular/core';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrl: './evaluation.component.scss'
})
export class EvaluationComponent {
  items = [
  {
    title: 'تقييم مراكز خدمات الاستثمار ',
    content: '   عميلنا العزيز: فى ضوء التزامنا بالتحسين المستمر للخدمات المقدمة خلال مراكز خدمات الاستثمار ، نود دعوتك للمشاركة في استبيان رضا العملاء. نشكرك لمساعدتنا في فهم احتياجاتك وتوقعاتك ، لتقديم أفضل الخدمات التي تلبي متطلباتك. ',
    link: 'https://customerfeedback.gafi.gov.eg/ar/Survey/egJRA2xwhwaAZOhcwGvHgQ==',
    expanded: false,
  },
  {
    title: '  تقييم  خدمة التراخيص ',
    content: ' عميلنا العزيز: فى ضوء حرصنا على تحقيق نيل رضاؤكم ننتظر مساهماتكم فى استيفاء الاستبيان عن خدمة التراخيص خلال الرابط التالى:',
    link: 'https://customerfeedback.gafi.gov.eg/ar/Survey/cAUXofI7WCmqm173wht3Iw==',
    expanded: false,
  },]
  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
